import { Img, Lightning, Log, Utils, AppData } from '@lightningjs/sdk'
import { Channel,LayoutConfig} from '../lib/app-api-config'
import { Icon, Shadow } from '@lightningjs/ui-components'
import { AppSetup } from '../lib/app-setup'
import { Theme } from './info-ui'
import { log } from 'console'
import { Helper } from '../lib/helper'
export interface MenuItemTemplateSpec extends Lightning.Component.TemplateSpecLoose {

}
export default class MenuItem
  extends Lightning.Component<MenuItemTemplateSpec>
  implements Lightning.Component<MenuItemTemplateSpec>
{
  _theme: Theme = {};
  channel!: Channel
  _blockItem = false
  selected = false
  private _focusAnimation: Lightning.types.Animation | undefined = undefined
  static override _template(): Lightning.Component.Template<MenuItemTemplateSpec> {
    return {
      MenuItemWrapper: {
        x: 0,
        y: 0,
        w: (w) => w,
        h: (h) => h,
        rect: true,
        color: 0x00000000,
        Selected: {
          x: (w)=>w,
          y: (h) => h/2,
          w: 6,
          h: 72,
          mountX: 1,
          mountY:0.5,
          rect: true,
          alpha:0,
          color: 0xffec0110,
        },
        
        MenuItemIcon: {
          x: 48,
          y: (h) => h/2,
          w: 72,
          h: 72,
          mountY:0.5,
          Shadow: {
            x: 48-12,
            y: (h) => h/2,
            w: 50,
            h: 50,
            type: Shadow,
            maskShadow:true,
            mount:0.5,
            mode: 'unfocused',
            style: {
              spread:1,
              color:0x99000000,
              offsetX: 0,
              offsetY: 0
            }
          },
        },
        MenuItemName: {
          x: 145,
          y:(h) => (h/2)+4,
          w: 554,
          mountY:0.5,
          text: { text: '', fontSize: 40, fontFace: Helper.getFontFamily('Regular'), textColor: 0xff999999, textOverflow: 'hidden', letterSpacing: 1.33 },
        },
        BlockItem : {
            w: (w) => w,
            h: (h) => h,
            rect:true,
            color: 0xAA222222,
            Icon: {
                mountX:0,
                type: Icon,
                x: 50,
                y: 5,
                w:27,
                h:27,
                icon: Utils.asset('/svg/ico-block.svg'),
            },
            shader: {},
            visible:false
        }
      }
    }
  }

  _handleHover(target) {
   // console.log('MenuItemHover: ',  target.ref)
    return false
  }

  _handleUnhover(target) {
   // console.log('MenuItemUnhover: ',  target.ref)
    return false
  }

  _handleClick(target) {
   // console.log('MenuItemClick: ',  target.ref)
    this.fireAncestors('$handleClick',target)
  }

  updateBlockItem() {
    this.tag('BlockItem').visible = this.channel.blockItem;
  }

  override _handleEnter() {
    this.fireAncestors('$ItemSelected')
  }

  override _init() {
    const { appState } = AppData as AppSetup
    const app = appState?.getApp();
    this._theme = (app?.themesObj as Theme) || {};
    const appApiConfig = appState?.getAppApiConfig()
    this._theme.textSize=  appApiConfig?.appLayoutConfig?.textSize || 40
    this._theme.textcolor=`0xff${appApiConfig?.appLayoutConfig?.textcolor}` || '0xffffffff'
    this._theme.gridfocuscolor= `0xff${appApiConfig?.appLayoutConfig?.gridfocuscolor}` || '0xffffffff'
    const gridFocusColor=parseInt(this._theme.gridfocuscolor)
    this._theme.bgcolor=`0xff${appApiConfig?.appLayoutConfig?.bgcolor}` || '0xffffffff'

    let iconName = this.getIcons(this.channel.name)
    const iconUrl = this.channel.name.toLowerCase() == 'search' ? this.channel.search_root_icon : (this.channel.name.toLowerCase() == 'more' ? this.channel.moreImage : this.channel.root_icon)
    const iconUrlSelected = this.channel.name.toLowerCase() == 'search' ? this.channel.search_root_icon_select : (this.channel.name.toLowerCase() == 'more' ? this.channel.moreSelectImage : this.channel.root_icon_select)
    
    this.tag('Selected').color = gridFocusColor || 0xffec0110;
    Log.info('MenuItemIcon: ', this.channel,  iconUrl, iconUrlSelected)
    this.patch({
      MenuItemWrapper: {
        Selected: {
          alpha: (this.selected ? 1 : 0),
        },
        MenuItemIcon: {
          IconSelected: {
            alpha: (this.selected ? 1 : 0),
            icon: iconUrlSelected,
            type: Icon,
            color: 0xffffffff,
            fixed: true
          },
          Icon: {
            alpha: (this.selected ? 0 : 1),
            icon: iconUrl,
            type: Icon,
            fixed: true
          }
        },
        MenuItemName: {
          text: { x: 0, text: Helper.capitalizeFirstLetter(this.channel.name, false), fontSize: this._theme.textSize, textColor:this._theme.textcolor, fontFace: Helper.getFontFamily('Regular'), letterSpacing: 1.33  },
        },
      },
    })
    // if (this.channel.name.toLowerCase() == 'search') {
    //   this.patch({
    //     MenuItemWrapper: {
    //       MenuItemIcon: {
    //         Icon: {
    //           w: 75,
    //           h: 75,
    //           x:-20,
    //           y:-20,
    //           icon: iconUrl,
    //           type: Icon,
    //           style: {
    //             color: '#ffffff',
    //           }
    //         }
    //       },
    //     },
    //   });
    // }
    this._focusAnimation = this.animation({
      duration: 0.5,
      actions: [
        { t: 'MenuItemWrapper', p: 'color', v: { 0: 0x00000000, 1: gridFocusColor || 0xffec0110  } },
        //{ t: 'MenuItemIcon', p: 'scale', v: { 0: 1, 1: 1.1 } },
        { t: 'MenuItemName', p: 'x', v: { 0: 145, 1: 120 } }
        //{ t: 'Selected', p: 'color', v: { 0: 0x00000000, 1: gridFocusColor ||0xffec0110 } },
      ],
    });
  }

  getIcons(name: string) {
    if (name.toLowerCase().indexOf('search') >= 0) return 'svg/ico-search'
    if (name.toLowerCase().indexOf('home') >= 0) return 'svg/ico-home'
    if (name.toLowerCase().indexOf('movie') >= 0) return 'svg/ico-movies'
    if (name.toLowerCase().indexOf('tv') >= 0) return 'svg/ico-tv'
    if (name.toLowerCase().indexOf('recently') >= 0) return 'svg/ico-new'
    if (name.toLowerCase().indexOf('recommended') >= 0) return 'svg/ico-fav'
    if (name.toLowerCase().indexOf('collection') >= 0) return 'svg/ico-fav'
    return 'svg/ico-new.svg'
  }

  override _focus() {
    if (this._focusAnimation) {
      if (this.selected) {
        this.tag('Shadow').mode = 'focused'  
        //this._focusAnimation.finish()
      } else {
        //this._focusAnimation.start()
      }
      
      this._focusAnimation.start()
    }
    const { platform } = AppData as AppSetup
    platform?.textToSpeach(this.channel.name)
  }

  override _unfocus() {
    /*if (this._focusAnimation && !this.selected) {
      this._focusAnimation.stop()
    }*/
    this.tag('Shadow').mode = 'unfocused'
    if (this._focusAnimation) {
      this._focusAnimation.stop()
    }
  }


  set item(itemInfo: any) {
    Log.info('MenuItem setItem: ', itemInfo, (itemInfo.selected ? true : false), itemInfo.channel.root_icon, this.itemSelected)
    this.channel = itemInfo.channel as Channel
    this.selected = itemInfo.selected ? true : false
    this.updateBlockItem();
  }
}
